import { Checkbox } from 'antd';
import { CustomerSearchSelect } from '../../customers/public/CustomerSearchSelect';
import { ZoneSearchSelect } from '../../zones/public/ZoneSearchSelect';
import { useCanFilterByCustomer } from '../hooks/use-can-filter-by-customer';
import type { LiveTruckFilters } from '../policies/live-truck-filters';
import { TRUCK_MAP_STATUS_LABELS, TRUCK_MAP_STATUSES } from '../policies/truck-map-status';

interface LiveMapFiltersProps {
  filters: LiveTruckFilters;
  onChange: (filters: LiveTruckFilters) => void;
}

/** Narrows the map in the browser: the whole fleet is already here, and a map of one page would be wrong. */
export function LiveMapFilters({ filters, onChange }: LiveMapFiltersProps) {
  const canFilterByCustomer = useCanFilterByCustomer();
  return (
    <div className="flex flex-wrap items-center gap-x-4 gap-y-2">
      <Checkbox.Group
        aria-label="Status"
        value={filters.statuses}
        options={TRUCK_MAP_STATUSES.map((status) => ({ value: status, label: TRUCK_MAP_STATUS_LABELS[status] }))}
        onChange={(statuses) => onChange({ ...filters, statuses })}
      />
      {canFilterByCustomer && (
        <div className="w-56">
          <CustomerSearchSelect allowClear value={filters.customerId} onChange={(customerId) => onChange({ ...filters, customerId })} />
        </div>
      )}
      <ZoneSearchSelect
        aria-label="Origin"
        placeholder="Origin"
        className="w-48"
        value={filters.originZoneCode}
        onChange={(originZoneCode) => onChange({ ...filters, originZoneCode })}
      />
      <ZoneSearchSelect
        aria-label="Destination"
        placeholder="Destination"
        className="w-48"
        value={filters.destinationZoneCode}
        onChange={(destinationZoneCode) => onChange({ ...filters, destinationZoneCode })}
      />
    </div>
  );
}
